import { render, staticRenderFns } from "./float-go-top.vue?vue&type=template&id=0638a8f4&scoped=true&"
import script from "./float-go-top.vue?vue&type=script&lang=js&"
export * from "./float-go-top.vue?vue&type=script&lang=js&"
import style0 from "./float-go-top.vue?vue&type=style&index=0&id=0638a8f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0638a8f4",
  null
  
)

export default component.exports